import { LOAD_SUB_CATEGORY } from "./actions";

const initialState = {
  content: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SUB_CATEGORY:
      return { ...state, content: action.content };
    default:
      return state;
  }
};
